export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            联络我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            剧集推荐、问题反馈或商务合作，欢迎随时联系我们
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
            <div className="flex flex-col items-center text-center gap-4">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-mail-send-line text-2xl text-accent-600"></i>
              </div>
              <div>
                <h3 className="text-base font-medium text-foreground-800 mb-2">投稿与咨询</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  如果您有想看的剧集、发现片源问题，或有任何建议，
                  欢迎通过以下方式联系我们。我们的团队会在24小时内回复。
                </p>
              </div>
              <a
                href="mailto:contact@51yingshi.com"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                发送邮件
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}